// src/components/Profile/Profile.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Form, Row, Col, Alert } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import {
  FaEdit,
  FaMapMarkerAlt,
} from "react-icons/fa";
import Header from "../../components/Header/Header";
import CourseSidebar from "../../components/SideBar/CourseSidebar";
import { hooks } from "../../studentportal-sdk";
import SideBar from "../../components/SideBar/AdminSideBar";
import { availableRegions } from "../../constant";

// Adjust the path as needed

const Profile = (props) => {
  // State for modal visibility
  const [showModal, setShowModal] = useState(false);

  const {
    userService: {
      store: { authUser },
      action: { updateProfile },
    },
  } = props;

  // console.log({ authUser });
  // State for profile data
  /* eslint-disable */

  const [profileData, setProfileData] = useState({
    userId: authUser.id,
    firstname: authUser.firstname || "",
    lastname: authUser.lastname || "",
    dob: authUser.dob || "",
    phone: authUser.phone || "",
    address: authUser.address || "",
    group: authUser.group || "",
    level: authUser.level || "",
    category: authUser.category || "",
  });

  // State for form submission feedback
  const [submissionStatus, setSubmissionStatus] = useState({
    success: null,
    message: "",
  });

  // React Hook Form setup
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: profileData,
  });

  // Handler to open the edit modal
  const handleEdit = () => {
    reset(profileData); // Reset form with current profile data
    setShowModal(true);
  };

  // Handler to close the edit modal
  const handleClose = () => {
    setShowModal(false);
    setSubmissionStatus({ success: null, message: "" });
  };

  // Handler for form submission
  const onSubmit = (data) => {
    // Update profile data
    // setProfileData(data);
    updateProfile(data);
  };

  const role = localStorage.getItem("role");

  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        {role === "admin" && <SideBar />}
        {role === "user" && <CourseSidebar />}

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <Row>
                <Col>
                  <h3 className="page-title">Profile</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Profile</li>
                  </ul>
                </Col>
              </Row>
            </div>
            {/* /Page Header */}

            {/* Profile Header */}
            <div className="profile-header mb-5">
              <Row className="align-items-center">
                <Col md="auto" className="profile-image mb-3 mb-md-0">
                  <img
                    className="rounded-circle"
                    alt="User"
                    src="./profile.png"
                    width="150"
                    height="150"
                  />
                </Col>
                <Col className="profile-user-info">
                  <h4 className="user-name mb-0">
                    {authUser?.firstname + " " + authUser?.lastname}
                  </h4>
                  <h6 className="text-muted">{authUser?.role}</h6>
                  <div className="user-location mb-2">
                    <FaMapMarkerAlt className="me-1" />
                    {authUser?.category}
                  </div>
                  {/* <p className="about-text">{profileData.about}</p> */}
                </Col>
                <Col md="auto" className="profile-btn">
                  <Button variant="primary" onClick={handleEdit}>
                    <FaEdit className="me-1" />
                    Edit Profile
                  </Button>
                </Col>
              </Row>
            </div>
            {/* /Profile Header */}

            {/* Profile Menu */}
            <div className="profile-menu mb-4">
              <ul className="nav nav-tabs nav-tabs-solid">
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    data-bs-toggle="tab"
                    to="#about_tab"
                  >
                    About
                  </Link>
                </li>
                {/* <li className="nav-item">
                  <Link
                    className="nav-link"
                    data-bs-toggle="tab"
                    to="#password_tab"
                  >
                    Password
                  </Link>
                </li> */}
              </ul>
            </div>
            {/* /Profile Menu */}

            {/* Tab Content */}
            <div className="tab-content profile-tab-cont">
              {/* About Tab */}
              <div className="tab-pane fade show active" id="about_tab">
                {submissionStatus.success && (
                  <Alert
                    variant="success"
                    onClose={() =>
                      setSubmissionStatus({ success: null, message: "" })
                    }
                    dismissible
                  >
                    {submissionStatus.message}
                  </Alert>
                )}
                <Row>
                  {/* Personal Details */}
                  <Col lg={9} className="mb-4">
                    <div className="card shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title d-flex justify-content-between align-items-center mb-4">
                          Personal Details
                          <Button
                            variant="link"
                            onClick={handleEdit}
                            className="p-0 text-decoration-none"
                          >
                            <FaEdit className="me-1" />
                            Edit
                          </Button>
                        </h5>
                        <Row>
                          <Col sm={4}>
                            <strong>Name</strong>
                          </Col>
                          <Col sm={8}>
                            {authUser?.firstname + " " + authUser?.lastname}{" "}
                          </Col>
                        </Row>
                        {/* <hr />
                        <Row>
                          <Col sm={4}>
                            <strong>Date of Birth</strong>
                          </Col>
                          <Col sm={8}>
                            {new Date(
                              profileData.dob
                            ).toLocaleDateString()}
                          </Col>
                        </Row> */}
                        <hr />
                        <Row>
                          <Col sm={4}>
                            <strong>Email ID</strong>
                          </Col>
                          <Col sm={8}>{authUser?.email}</Col>
                        </Row>
                        <hr />
                        <Row>
                          <Col sm={4}>
                            <strong>Mobile</strong>
                          </Col>
                          <Col sm={8}>{authUser?.phone}</Col>
                        </Row>
                        <hr />
                        <Row>
                          <Col sm={4}>
                            <strong>Address</strong>
                          </Col>
                          <Col sm={8}>{profileData.address || "SA"}</Col>
                        </Row>
                        <hr />
                        <Row>
                          <Col sm={4}>
                            <strong>KingsChat Handle</strong>
                          </Col>
                          <Col sm={8}>{profileData.address}</Col>
                        </Row>
                        <hr />
                        <Row>
                          <Col sm={4}>
                            <strong>Level</strong>
                          </Col>
                          <Col sm={8}>{profileData.level}</Col>
                        </Row>
                        <hr />
                        <Row>
                          <Col sm={4}>
                            <strong>Group</strong>
                          </Col>
                          <Col sm={8}>{profileData.group}</Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                
                </Row>
              </div>
            
            </div>
            {/* /Tab Content */}
          </div>
        </div>
      </div>

      {/* Edit Profile Modal */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Profile</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body>
            {/* Name */}
            <Form.Group className="mb-3" controlId="formName">
              <Form.Label>First Name</Form.Label>
              <Controller
                name="firstname"
                control={control}
                // rules={{ required: "Name is required." }}
                render={({ field }) => (
                  <Form.Control
                    type="text"
                    placeholder="Enter First name"
                    {...field}
                    isInvalid={errors.firstname}
                    defaultValue={authUser?.firstname}
                  />
                )}
              />
              <Form.Control.Feedback type="invalid">
                {errors.firstname?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formName">
              <Form.Label>Last Name</Form.Label>
              <Controller
                name="lastname"
                control={control}
                // rules={{ required: "Name is required." }}
                render={({ field }) => (
                  <Form.Control
                    type="text"
                    placeholder="Enter Last name"
                    {...field}
                    isInvalid={errors.lastname}
                    defaultValue={authUser?.lastname}
                  />
                )}
              />
              <Form.Control.Feedback type="invalid">
                {errors.lastname?.message}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Date of Birth */}
            <Form.Group className="mb-3" controlId="formDOB">
              <Form.Label>Date of Birth</Form.Label>
              <Controller
                name="dob"
                control={control}
                // rules={{ required: "Date of Birth is required." }}
                render={({ field }) => (
                  <Form.Control type="date" {...field} isInvalid={errors.dob} />
                )}
              />
              <Form.Control.Feedback type="invalid">
                {errors.dob?.message}
              </Form.Control.Feedback>
            </Form.Group>
            {/* Mobile */}
            <Form.Group className="mb-3" controlId="formMobile">
              <Form.Label>Mobile</Form.Label>
              <Controller
                name="phone"
                control={control}
                rules={{
                  // required: "Mobile number is required.",
                  pattern: {
                    value: /^[0-9-+\s()]*$/,
                    message: "Invalid mobile number.",
                  },
                }}
                render={({ field }) => (
                  <Form.Control
                    type="text"
                    placeholder="Enter mobile number"
                    // {...field}
                    isInvalid={errors.phone}
                    defaultValue={authUser?.phone}
                  />
                )}
              />
              <Form.Control.Feedback type="invalid">
                {errors.phone?.message}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Address */}
            <Form.Group className="mb-3" controlId="formAddress">
              <Form.Label>Address</Form.Label>
              <Controller
                name="address"
                control={control}
                // rules={{ required: "Address is required." }}
                render={({ field }) => (
                  <Form.Control
                    as="textarea"
                    rows={2}
                    placeholder="Enter address"
                    {...field}
                    isInvalid={errors.address}
                  />
                )}
              />
              <Form.Control.Feedback type="invalid">
                {errors.address?.message}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-group">
              <label>
                Group <span className="login-danger">*</span>
              </label>
              <Controller
                name="group"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <>
                    <select
                      className={`form-control ${
                        errors?.category ? "error-input" : ""
                      }`}
                      type="text"
                      value={value}
                      onChange={onChange}
                    >
                      <option className="form-control" value="">
                        Select Group
                      </option>
                      {availableRegions.map((region) => (
                        <option className="form-control" value={region}>
                          {region}
                        </option>
                      ))}
                    </select>
                  </>
                )}
                defaultValue={authUser?.group}
              />
              <small>{errors?.group?.message}</small>
            </Form.Group>

            <Form.Group className="form-group">
              <label>
                Leadership Category <span className="login-danger">*</span>
              </label>
              <Controller
                name="category"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <>
                    <select
                      className={`form-control ${
                        errors?.category ? "error-input" : ""
                      }`}
                      type="text"
                      value={value}
                      onChange={onChange}
                    >
                      <option className="form-control" value="">
                        Select Category
                      </option>
                      <option className="form-control" value="Cell Leader">
                        Cell Leader
                      </option>
                      <option
                        className="form-control"
                        value="Code Rabah Cell Leader"
                      >
                        Code Rabah Cell Leader
                      </option>
                      <option
                        className="form-control"
                        value="Bible Study Class Teacher"
                      >
                        Bible Study Class Teacher
                      </option>
                      <option className="form-control" value="PCF Leader">
                        PCF Leader
                      </option>
                      <option className="form-control" value="Group Pastor">
                        Group Pastor
                      </option>
                      <option className="form-control" value="Graduate Pastor">
                        Graduate Pastor
                      </option>
                      <option className="form-control" value="Church Pastor">
                        Church Pastor
                      </option>
                      <option
                        className="form-control"
                        value="Senior Cell Leader"
                      >
                        Senior Cell Leader
                      </option>
                      <option className="form-control" value="Deaconry">
                        Deaconry
                      </option>
                    </select>
                    <span className="profile-views">
                      <i className="fas fa-users" />
                    </span>
                  </>
                )}
                defaultValue={authUser?.category}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* /Edit Profile Modal */}
    </>
  );
};

export default (props) => <Profile {...hooks.UserManagement(props)} />;
